import { MenuItem, Select, TextField } from "@mui/material";
import { Formik } from "formik";
import Header from "../../components/Header/Header";
import consentFormImg from "../../assets/consentFormImg.png";
import * as Yup from "yup";
import { useAddQueryContactUsMutation } from "../../redux/services/contactUsApi";
import { useEffect, useState } from "react";
import MuiAlert from "../MuiAlert/MuiAlert";
import { useGetEnumDataMutation } from "../../redux/services/enumApi";
import Loading from "../commons/Loading";
import Powerdby from "../../assets/poweredby.png";
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { TiMail } from "react-icons/ti";
import { BsTelephone } from "react-icons/bs";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { BiSupport } from "react-icons/bi";
import RegularButton from "../../components/Buttons/RegularButton";
import Footer from "../../components/Footer/Footer";

type Props = {};

const contactFormSchema = Yup.object().shape({
  emailId: Yup.string().email().required("Email is required").trim(),
  reason: Yup.string().required("Reason is required").trim(),
  description: Yup.string().required("Description is required").trim(),
});

const ContactUs = (props: Props) => {
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;
  const navigate = useNavigate();
  const [contactSupport, contactSupportResponse] =
    useAddQueryContactUsMutation();
  const [statusCodes, setStatusCodes] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  const [reason, setReason] = useState([]);
  const [char, setChar] = useState(0);

  useEffect(() => {
    getEnumData({});
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      setReason(enumResponse?.data?.CONTACT_SUPPORT);
    } else if (enumResponse.isError) {
    }
  }, [enumResponse.isSuccess, enumResponse.isError]);

  const handleSubmitForm = (values: any) => {
    contactSupport({
      payload: {
        email: values.emailId,
        contactType: values.reason,
        description: values.description,
        status: true,
      },
    });
  };

  useEffect(() => {
    if (contactSupportResponse.isSuccess) {
      setStatusCodes({ type: "success", code: "CONSENT_FORM_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    } else if (contactSupportResponse.isError) {
      let errorData: any = contactSupportResponse.error;
      let errorMessage = errorData.error || errorData.data.serviceErrors[0].msg;
      if (errorMessage === "Query Contact already Present.") {
        setStatusCodes({ type: "error", code: "REQUEST_EXIST_ERROR" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      } else if (
        errorMessage === "User not found. Please contact service desk."
      ) {
        setStatusCodes({ type: "error", code: "USER_NOT_EXISTS" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      } else {
        setStatusCodes({ type: "error", code: "CONSENT_FORM_ERROR" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      }
    }
  }, [contactSupportResponse.isSuccess, contactSupportResponse.isError]);

  const handleChangeChar = (e: any) => {
    const data = e.target.value.split("");
    if (data.length <= 200) {
      setChar(data.length);
    }
  };

  return (
    <div className="flex flex-col justify-between">
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
      </div>
      <div
        className="py-4 px-10 lg:h-[880px] md:h-[1400px]  h-[1200px] "
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: "#60869e",
          background: `url(${require("../../assets/becomeAPartner.png")}) center center repeat`,
        }}
      >
        {enumResponse.isLoading ? <Loading /> : null}
        <div
          className=" md:pt-40 lg:pt-28 pt-28"
          style={{
            backgroundSize: "cover",
            objectFit: "contain",
            backgroundPosition: "center",
            width: "100%",
            height: "800px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {isAlertVisible && (
            <div>
              <MuiAlert
                severity={statusCodes?.type!}
                messageType={statusCodes?.code!}
              />
            </div>
          )}
          <div className="flex lg:flex-row flex-col lg:gap-24 gap-10 lg:w-full justify-center lg:justify-items-start justify-items-center lg:p-0 md:p-24 ">
            <div className="flex lg:justify-start flex-col justify-center ">
              <h1 className=" md:text-[36px] font-bold text-white grid-cols-4 mb-2 text-[25px]">
                Contact Form
              </h1>
              <Formik
                validationSchema={contactFormSchema}
                initialValues={{
                  emailId: "",
                  reason: "",
                  description: "",
                }}
                onSubmit={handleSubmitForm}
              >
                {({
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  handleReset,
                  values,
                  touched,
                  errors,
                }) => (
                  <div>
                    <div className="flex flex-col mt-3 gap-1">
                      <label className="text-white font-normal text-[20px]">
                        Email ID
                      </label>
                      <TextField
                        variant="outlined"
                        color="error"
                        size="small"
                        placeholder="Enter email id"
                        id={"emailId"}
                        name={"emailId"}
                        type="email"
                        value={values.emailId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          backgroundColor: "white",
                          borderRadius: "2px",
                        }}
                        className="appearance-none rounded w-full p-2  leading-tight focus:outline-none focus:shadow-outline border-b font-bold"
                      />
                      <div className="text-[#E23744] text-lg ">
                        {errors.emailId}
                      </div>
                    </div>
                    <div className="flex flex-col mt-3 gap-1">
                      <label className="justify-start text-white font-normal text-[20px]">
                        Select reason
                      </label>
                      <Select
                        size="small"
                        color="error"
                        id={"reason"}
                        name={"reason"}
                        value={values.reason}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          backgroundColor: "white",
                          borderRadius: "2px",
                          border: 0,
                          boxShadow: "none",
                        }}
                        className="appearance-none rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-b font-bold "
                        displayEmpty
                        defaultValue={""}
                      >
                        <MenuItem disabled value="">
                          Select reason
                        </MenuItem>
                        {reason &&
                          reason.map((reason: any) => (
                            <MenuItem value={reason.code} key={reason.code}>
                              {reason.displayValue}
                            </MenuItem>
                          ))}
                      </Select>
                      <div className="text-[#E23744] text-lg ">
                        {errors.reason}
                      </div>
                    </div>
                    <div className="flex flex-col mt-3 gap-1">
                      <label className=" justify-start text-white font-normal text-[20px]">
                        Description
                      </label>
                      <div>
                        <TextField
                          color="error"
                          variant="outlined"
                          size="small"
                          placeholder="Enter description"
                          id={"description"}
                          name={"description"}
                          value={values.description}
                          onChange={handleChange}
                          onKeyUp={(e) => handleChangeChar(e)}
                          multiline
                          rows={5}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 200 }}
                          style={{
                            backgroundColor: "white",
                            borderRadius: "2px",
                          }}
                          className="appearance-none rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-b md:font-bold font-normal text-sm md:text-lg"
                        />
                        <div className="flex text-gray-500 md:text-lg justify-end relative top-[-30px] mr-3 text-sm">
                          {char}/200
                        </div>
                      </div>
                      <div className="text-[#E23744] text-lg relative top-[-25px]">
                        {errors.description}
                      </div>
                    </div>
                    <div className="lg:flex sm:flex-row md:items-end gap-5 mt-5 lg:ml-[98px] ml-[58px] md:ml-0">
                      <button
                        className="h-14 md:w-[150px] w-[60%] bg-transparent rounded text-white p-3 font-bold text-[20px]"
                        onClick={() => {
                          handleReset();
                        }}
                      >
                        Cancel
                      </button>
                      <RegularButton
                        className="h-[52px] md:w-[180px] w-[60%] rounded text-white font-bold text-[20px]"
                        onClick={() => {
                          handleSubmit();
                        }}
                        title={"Submit"}
                      />
                    </div>
                  </div>
                )}
              </Formik>
            </div>

            <div className="flex lg:justify-start justify-center ">
              <div className="lg:mt-[20px]">
                <img src={consentFormImg} className="rounded-2xl" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default ContactUs;
